export const defaultBreakpoints = [
    '768px',
    '1024px',
    '1440px',
];
const [m, l, xl] = defaultBreakpoints;
defaultBreakpoints.m = m;
defaultBreakpoints.l = l;
defaultBreakpoints.xl = xl;
//# sourceMappingURL=defaultBreakpoints.js.map